// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { paperPlane16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-paper-plane': IconPaperPlane;
    }
}

/**
 * The icon component for the 'paperPlane' icon
 */
export class IconPaperPlane extends Icon {
    public constructor() {
        super(paperPlane16X16);
    }
}

registerIcon('icon-paper-plane', IconPaperPlane);
export const iconPaperPlaneTag = 'nimble-icon-paper-plane';
